import React from 'react';
import AnalyticsChartFullscreenButton from './AnalyticsChartFullscreenButton';

/**
 * Fullscreen enter/exit control for a chart's title row (right of the title).
 *
 * - `presetSingleChartFullscreen`: always render the Exit control in the title.
 * - Otherwise (normal analytics): render the enter/exit control by the title
 *   ONLY below `lg` (compact — full label when there's room, icon-only on very
 *   small screens). At `lg+` this renders nothing, so the chart's own bottom-row
 *   control (hidden below `lg`) is used and desktop stays unchanged.
 * - Renders nothing when there are no fullscreen handlers (Home/widget paths).
 *
 * Centralizes the block that was duplicated across every chart's title row.
 */
const ChartFullscreenTitleControl = ({ analyticsFullscreen, presetSingleChartFullscreen }) => {
  if (presetSingleChartFullscreen && analyticsFullscreen?.onExit) {
    return (
      <AnalyticsChartFullscreenButton
        isActive
        onEnter={() => {}}
        onExit={analyticsFullscreen.onExit}
      />
    );
  }
  if (analyticsFullscreen?.onEnter && analyticsFullscreen?.onExit) {
    return (
      <div className="lg:hidden">
        <AnalyticsChartFullscreenButton
          compact
          isActive={analyticsFullscreen.isActive}
          onEnter={analyticsFullscreen.onEnter}
          onExit={analyticsFullscreen.onExit}
        />
      </div>
    );
  }
  return null;
};

export default ChartFullscreenTitleControl;
